import { Dispatcher } from "../../../../../../../../react-core/Flux/Dispatcher";
import { FluxResponse } from "../../../Store/Variable";
import { AccountModelPortfolioStatic } from "./AccountModelPortfolioStatic";
import { ChargesRedirectionStatic } from "./ChargesRedirectionStatic";
import { TransactionStatic } from "./TransactionStatic";

export const TransactionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const TransactionStore: TransactionStatic = new TransactionStatic();

//Account model portfolio static
export const AccountModelPortfolioDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const AccountModelPortfolioStore: AccountModelPortfolioStatic = new AccountModelPortfolioStatic();

//Charges
export const ChargesRedirectionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ChargesRedirectionStore: ChargesRedirectionStatic = new ChargesRedirectionStatic();
